module.exports = "/admin_success_screen-c0c0264dada08fe6be21d95c8b17e2f9.svg";